import { IElementData } from 'components/common/element-data/types';
import { format } from 'date-fns/format';

export const metadataSettingsPreviewData: IElementData = {
    elementType: 'metric',
    certifiedInd: true,
    certificationLevelColor: 'success.main',
    //certificationLevelName: tile.certification_level_name,
    lastCertifiedByName: 'Valentyn Hnot',
    lastCertifiedTime: format(new Date('08/13/2023'), 'M/dd/yyyy'),
    descriptionMarkdownInd: false,
    description:
        'The "Sales Performance Analysis" report offers a comprehensive examination of sales data to uncover critical trends and identify lucrative opportunities for growth within the market. By analyzing key performance indicators such as revenue, conversion rates, and customer demographics, businesses can gain valuable insights into their sales strategies. Additionally, the report highlights potential areas for improvement, enabling teams to optimize their efforts and maximize profitability. With these insights, organizations can make informed decisions to enhance their sales processes and drive sustainable growth in a competitive landscape.',
    lastMeasurementValueFormatted: '$8.14M',
    lastMeasurementTimeFormatted: 'Monday 12/28/2020',
    metricTileDisplayPctVariance: -1.61,
    pctVarianceText: 'from last day',
    metricMovingAverageInterval: '30 day',
    movingAverageValue: '$7.96M',
    businessOwner: 'Sarah Johnson',
    businessOwnerEmail: 'sarah.johnson@email.com',
    technicalOwner: 'Jennifer Anderson',
    technicalOwnerEmail: 'jennifer.anderson@email.com',
    dataSteward: 'Emily Smith',
    dataStewardEmail: 'emily.smith@email.com',
    dataSourceName: 'Dataset',
    lastDisplayGenerationTime: '12/15/2025 03:13',
    engagement: 49,
    documents: [
        {
            documentId: 26,
            documentType: 'User Guide',
            sourceType: 'url',
            externalUrl: '#',
            isNewInd: false,
            isUpdatedInd: false,
            name: 'Release Notes & Definitions',
        },
        {
            documentId: 29,
            documentType: 'Release Note',
            sourceType: 'url',
            externalUrl: '#',
            isNewInd: false,
            isUpdatedInd: false,
            name: 'Definitions & Release Notes',
        },
    ] as any,
    topics: {
        'topic-type-7': {
            topic_type_name: 'Revenue',
            use_icon: 'fa',
            icon_type: 'fa',
            icon: null,
            fa_icon: 'fas chart-bar',
            display_order: 10,
            topics: [
                {
                    topic_id: 124,
                    name: 'Revenue Item',
                },
                {
                    topic_id: 125,
                    name: 'Revenue Item 2',
                },
            ],
        },
        'topic-type-8': {
            topic_type_name: 'Pointactives',
            use_icon: 'fa',
            icon_type: 'fa',
            icon: null,
            fa_icon: 'fas suitcase',
            display_order: 11,
            topics: [
                {
                    topic_id: 126,
                    name: 'Pointactives Item',
                },
            ],
        },
        'topic-type-9': {
            topic_type_name: 'Customer Count',
            use_icon: 'fa',
            icon_type: 'fa',
            icon: null,
            fa_icon: 'far user',
            display_order: 11,
            topics: [
                {
                    topic_id: 127,
                    name: 'Admin',
                },
            ],
        },
        'default-topic-type': {
            topic_type_name: 'Tags',
            use_icon: null,
            icon_type: null,
            icon: null,
            fa_icon: null,
            display_order: null,
            topics: [
                {
                    topic_id: 1774,
                    name: 'Sales',
                },
                {
                    topic_id: 1775,
                    name: 'Country',
                },
            ],
        },
    } as any,
    customFields: [
        {
            cfs_id: 5,
            label: 'Custom Field Section',
            fields: [
                {
                    name: 'Country',
                    type: 'textarea',
                    id: 173,
                    supportRestriction: false,
                    values: ['Canada'],
                },
                {
                    name: 'Channel',
                    type: 'textarea',
                    id: 174,
                    supportRestriction: false,
                    values: ['Cost'],
                },
            ],
        },
        {
            cfs_id: 6,
            label: 'Custom Field Section #2',
            fields: [
                {
                    name: 'Date',
                    type: 'textarea',
                    id: 175,
                    supportRestriction: false,
                    values: ['Sunday 10/30/2022'],
                },
            ],
        },
    ] as any,
};
